import React from 'react';
import RatingStar from '../../../Common/RatingStar';
import { composeArrayForRatings } from '../../../Common/CommonMethods';
import ImageLoader from '../../../Common/ImageLoader';
import { withRouter } from 'react-router-dom';

const SponsoredBoxNew = (props) => {
  return (
    <div className="competitor_block sponsored_block">
      <div className="top_header_text_block">
        <span className="header_txt">
          Don't see enough customer references?
        </span>
        {`Check out this ${props.vendorCommon.name} competitor`}
      </div>
      <div className="competitor_box">
        <ul>
          <li>
            <ul>
              <div className="ribbon ribbon-top-right sponsored">
                <span>
                  <div className="ribbonTxt">SPONSORED</div>
                </span>
              </div>
              <li
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(
                    `${props.vendorCommon.sponsored.profile_url}`
                  );
                }}
              >
                <div className="logo">
                  <ImageLoader
                    image={props.vendorCommon.sponsored.logo}
                    fallbackImage={'/static/images/FC-Generic-Logo.webp'}
                  />
                </div>
                {!!props.vendorCommon &&
                  Object.keys(props.vendorCommon.sponsored).length > 0 && (
                    <span className="clsRating">
                      <React.Fragment>
                        {props.vendorCommon.sponsored.rating.aggregate_score}
                        <RatingStar
                          starCount={composeArrayForRatings(
                            props.vendorCommon.sponsored.rating.aggregate_score
                          )}
                        />
                      </React.Fragment>
                    </span>
                  )}
                <div className="customers_Num">
                  <span className="number">
                    {props.vendorCommon.sponsored.reviews_count}
                  </span>
                  Customer References
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default withRouter(SponsoredBoxNew);
